import { RootState } from '../../interfaces/rootState';

// surgeonList default to preferred for office and all surgeons with a hospital case for OR
export const PreferredSurgeonsSelector = ({ surgeonList: { surgeonList } }: RootState) => surgeonList;

export const FullSurgeonsSelector = ({ surgeonList: { fullSurgeonList } }: RootState) => fullSurgeonList;
